export default {
  // Top Bar
  company: 'KR Corp',
  recruit: '채용',
  news: 'News',
  familySite: 'Family Site',
  
  // Navigation
  company_menu: '회사소개',
  business: '사업영역',
  portfolio: '포트폴리오',
  insights: 'Insights',
  contact: '문의하기',
  
  // Hero
  hero_title: '성공 비즈니스를 위한',
  hero_subtitle: '최적의 파트너',
  hero_description: '교육 콘텐츠 제작부터 라이브 송출까지, 전문 스튜디오 솔루션',
  cta_consult: '무료 상담 신청',
  cta_portfolio: '포트폴리오 보기',
  
  // Business Area
  business_title: 'Business Area',
  business_subtitle: '6대 핵심 비즈니스 영역',
  business_1_title: '교육 콘텐츠',
  business_1_desc: '이러닝, 홍보영상 등 고품질 제작',
  business_2_title: '라이브 송출',
  business_2_desc: '안정적인 웨비나 및 행사 중계',
  business_3_title: 'AI 솔루션',
  business_3_desc: 'AI 아나운서 및 자동 자막',
  business_4_title: '스튜디오 컨설팅',
  business_4_desc: '설계, 시공, 운영 매뉴얼 제공',
  business_5_title: '현장 촬영',
  business_5_desc: '전국 출장 및 중계 지원',
  business_6_title: '유지보수',
  business_6_desc: '연간 계약 및 품질 관리',
  
  // Portfolio
  portfolio_title: 'Success Stories',
  portfolio_projects: '누적 프로젝트',
  portfolio_delivery: '납기 준수율',
  portfolio_view_all: '전체 보기',
  portfolio_more: 'More Projects',
  
  // News
  news_title: 'KR Insights',
  news_view_all: 'View All',
  news_press: 'Press',
  news_blog: 'Blog',
  news_company: 'Company',
  
  // Partners
  partners_title: 'TRUSTED BY MARKET LEADERS',
  
  // Footer
  footer_tagline: '성공 비즈니스를 위한 최적의 파트너',
  footer_services: 'Services',
  footer_company: 'Company',
  footer_contact: 'Contact',
  footer_about: '회사소개',
  footer_careers: '채용정보',
  footer_location: '오시는 길',
  footer_privacy: '개인정보처리방침',
  footer_terms: '이용약관',
  footer_corp: '(주)KR스튜디오',
  footer_ceo: '대표: 김민규, 류인국',
  footer_rights: '© 2024 KR STUDIO. All rights reserved.',
  
  // Services
  service_content: '콘텐츠 제작',
  service_streaming: '라이브 스트리밍',
  service_consulting: '스튜디오 컨설팅',
  service_lms: 'LMS 운영',
};